export default __webpack_public_path__ + "static/media/2.63026b47.webp";